/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CertyfikatInstytucjiTo } from '../../models/certyfikat-instytucji-to';

export interface ApiWebInstytucjeNipCertyfikatyGet$Params {
  nip: string;
  wazne?: boolean;
  zatwierdzone?: boolean;
}

export function apiWebInstytucjeNipCertyfikatyGet(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipCertyfikatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CertyfikatInstytucjiTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipCertyfikatyGet.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.query('wazne', params.wazne, {});
    rb.query('zatwierdzone', params.zatwierdzone, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CertyfikatInstytucjiTo>>;
    })
  );
}

apiWebInstytucjeNipCertyfikatyGet.PATH = '/api/web/instytucje/{nip}/certyfikaty';
